import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Center,
  Box,
  Text,
  Link,
  Button,
  VStack,
} from '@chakra-ui/react';

import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link as ReactRouterLink } from 'react-router-dom';
import ResponsiveSVG from '../../Misc/ResponsiveSVG/ResponsiveSVG';
import { ReactComponent as SVGRouteSign } from '../../../assets/svg/road_sign.svg';
import { ReactComponent as SVGTeam } from '../../../assets/svg/team_up_route_opt.svg';
export default function HelpComponent() {
  const { t } = useTranslation();

  return (
    <Center>
      <VStack>
        <Box
          position={'absolute'}
          display={'flex'}
          w={['95%', null, null, null, '50%']}
          mr={['2.5%', null, null, null, '25%']}
          alignItems={'center'}
          justifyContent={'flex-start'}
        >
          <Link as={ReactRouterLink} to={'/'}>
            <Button
              color={'#242424'}
              alignSelf={'flex-end'}
              aria-label={t('help.back')}
              leftIcon={<ArrowBackIcon />}
              bgColor={'transparent'}
            >
              {t('help.back')}
            </Button>
          </Link>
        </Box>
        <Box
          w={['92.5%', null, null, null, '50%']}
          marginTop={20}
          textAlign={'center'}
          id="quienes-somos"
        >
          <ResponsiveSVG
            SVGImage={SVGRouteSign}
            widthArray={['70%', null, null, '40%']}
            ml={['15%', null, null, '30%']}
          />
          <Text textStyle={'paragraphHeading'} mt={10} mb={0}>
            {t('help.title')}
          </Text>
          <Center textAlign={'left'}>
            <Box w={['92.5%', null, null, null, '50%']} mt={15}>
              <ol>
                <li>
                  <Text textStyle={'paragraphBody'} pb={45}>
                    <b>{t('help.step1Title')}</b>
                    <br />
                    <Center pt={10}>
                      <Button colorScheme="green" isDisabled={true}>
                        {t('landing.create.title')}
                      </Button>
                    </Center>
                  </Text>
                </li>
                <li>
                  <Text textStyle={'paragraphBody'} pb={45}>
                    <b>{t('help.step2Title')}</b>
                    <br /> {t('help.step2Desc')}
                  </Text>
                </li>
                <li>
                  <Text textStyle={'paragraphBody'} pb={45}>
                    <b>{t('help.step3Title')}</b>
                    <br />
                    {t('help.step3Desc')}
                  </Text>
                </li>
                <li>
                  <Text textStyle={'paragraphBody'} pb={45}>
                    <b>{t('help.step4Title')}</b>
                    <br />
                    {t('help.step4Desc')}
                  </Text>
                </li>
                <ResponsiveSVG
                  SVGImage={SVGTeam}
                  widthArray={['70%', null, null, '40%']}
                  ml={['15%', null, null, '30%']}
                  mb={10}
                />
                <li>
                  <Text textStyle={'paragraphBody'} pb={45}>
                    <b>{t('help.step5Title')}</b>
                    <br />
                    {t('help.step5Desc')}
                  </Text>
                </li>
                <li>
                  <Text textStyle={'paragraphBody'} pb={45}>
                    <b>{t('help.step6Title')}</b>
                    <br />
                    {t('help.step6Desc')}
                  </Text>
                </li>
              </ol>
            </Box>
          </Center>
          <Text textAlign={'center'} textStyle={'paragraphBody'}>
            {t('help.betaText')}
          </Text>
        </Box>
      </VStack>
    </Center>
  );
}
